@switch (viewMode()) {
  @case ('add-edit') {
    <box>
      <app-header
        [hasBackButton]="true"
        [hasBottomBorder]="false"
        (back)="onBack()"
        [title]="(selectedDetail()?.id ? 'ship_interface.edit_inventory' : 'ship_interface.add_inventory') | transloco">
      </app-header>
      <app-body>
        <autofill
          [control]="form.get('inventory_item_id')"
          [hasPadding]="true"
          [label]="'ship_interface.inventory_item' | transloco"
          [placeholder]="'ship_interface.select_inventory_item' | transloco"
          [apiEndpoint]="VesselReportApi.inventoryItems"
          [options]="inventories()"
          [showError]="true"
          [errors]="{
            required: 'system.required' | transloco,
            requireMatch: 'system.no-free-text' | transloco
          }"
          selectType="id"
          displayName="name">
          <button customSuffix mat-icon-button (click)="onInventories(); $event.stopPropagation()">
            <mat-icon class="icon-size-5" [color]="'primary'" [svgIcon]="'heroicons_outline:magnifying-glass'" />
          </button>
        </autofill>
        <textbox
          [control]="form.get('description')"
          [hasPadding]="true"
          [label]="'ship_interface.description' | transloco"
          [placeholder]="'ship_interface.enter_description' | transloco">
        </textbox>
        <textbox
          [control]="form.get('value')"
          [hasPadding]="true"
          [label]="'ship_interface.month_end_rob' | transloco"
          [required]="true"
          [placeholder]="'0.00'"
          [decimal]="2"
          type="number"
          [unit]="form.get('inventory_item_unit')?.value">
        </textbox>
      </app-body>
      <app-footer
        [hasDiscardButton]="true"
        [hasTopBorder]="false"
        [onSave]="null"
        [hasSaveButton]="['monthly_rob_ship_interface', ['update']] | permission"
        (discard)="onDiscard()"
        (save)="onSave()"
        [hasDeleteButton]="!!selectedDetail()?.id"
        (delete)="onDelete()"
        [disabledSaveButton]="form.invalid">
      </app-footer>
    </box>
  }
  @case ('select-inventory') {
    <inventory-supplies (back)="viewMode.set('add-edit')" (save)="onSaveInventory($event)" />
  }
}
